export enum TravelType {
    GROUP = "GROUP",
    FAMILY = "FAMILY",
    INDIVIDUAL = "INDIVIDUAL",
    STUDENT = "STUDENT",
    MULTIPLE_INDIVIDUAL = "MULTIPLE_INDIVIDUAL"
}

export enum RwandaTravelType {
    INDIVIDUAL = "INDIVIDUAL",
    STUDENT = "STUDENT",
}